import { Flex } from '@/components/base';
import SelectModal from '@/components/Select/SelectModal';
import type { SelectOptionT } from '@/components/Select/types';
import { MainText } from '@/components/Typography/NamedTypo';
import { UNASSIGNED_LABEL } from '@/configs/reserved-word';
import useAgentStore from '@/features/Agent/stores';

export type Props = {
  selected: string;
  useShortcut?: boolean;
  name: string;
  triggerEl?: HTMLDivElement | null;
  onSelect: (key: string) => void;
  onClear?: () => void;
};

const AgentSelectModal = ({
  selected,
  useShortcut,
  name,
  onSelect,
  onClear,
  triggerEl,
}: Props) => {
  const agentMap = useAgentStore((state) => state.agentMap);

  const options: SelectOptionT[] = [
    ...Object.values(agentMap).map((agent) => ({
      value: agent.alias,
      searchName: agent.name,
    })),
  ];

  return (
    <SelectModal
      name={name}
      width="300px"
      searchOptions={{
        enable: true,
      }}
      data={() => {
        return {
          list: options,
          cursor: null,
        };
      }}
      mapper={(op) => {
        const agent = agentMap[op.value];
        if (!agent) {
          console.error(`Agent is not exist, ${op.value}`);
          return null;
        }
        return (
          <Flex g="6px" a="center">
            <MainText>{agent.name}</MainText>
            <MainText dim ellipsis>
              {agent.email}
            </MainText>
          </Flex>
        );
      }}
      value={selected}
      placeholder={UNASSIGNED_LABEL}
      onSelect={(key) => onSelect(key as string)}
      shortcut={useShortcut ? 'KeyA' : ''}
      onClear={onClear}
      triggerEl={triggerEl}
    />
  );
};

export default AgentSelectModal;
